'use client';

import { useRouter } from 'next/navigation';
import React, { Suspense } from 'react';
import { useSession } from 'next-auth/react';
import { UserMenu } from '@/components/UserMenu';
import landingStyles from '../styles/Landing.module.css';

function MainContent() {
  const router = useRouter();
  const { data: session } = useSession();

  const startMeeting = () => {
    if (!session) {
      router.push('/auth/signin');
    } else {
      router.push('/start');
    }
  };

  const scheduleMeeting = () => {
    router.push('/schedule');
  };

  return (
    <div className={landingStyles.container}>
      {/* Top Navigation */}
      <nav
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 1.5rem',
          background: 'rgba(5, 5, 5, 0.8)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
          zIndex: 100,
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
        }}
      >
        <a 
  href="/" 
  style={{ 
    display: "flex", 
    alignItems: "center", 
    gap: "0.75rem", 
    textDecoration: "none" 
  }}
>
  <img
    src="/images/logo.png"
    alt="Logo"
    style={{ height: "32px" }}
  />

  <div 
    style={{ 
      fontSize: "28px", 
      fontWeight: "bold", 
      fontFamily: "Arial", 
      display: "flex" 
    }}
  >
    <span style={{ color: "white" }}>Skill</span>
    <span style={{ color: "hsla(135, 62%, 49%, 1)" }}>mate</span>
  </div>
</a>
       
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {session && (
            <button
              onClick={() => router.push('/dashboard')}
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.2s',
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              Dashboard
            </button>
          )}
          <UserMenu />
        </div>
      </nav>

      <div className={landingStyles.navSpacer} />

      {/* Hero Section */}
      <section className={landingStyles.hero}>
        <h1 className={landingStyles.heroTitle}>
     Enterprise-Grade Secure Meeting Platform for Modern Teams
        </h1>
        <p className={landingStyles.heroDescription}>
         A modern platform built for professional meetings.
Schedule effortlessly with secure authentication.
Stay organized with seamless session management.
        </p>
        <div className={landingStyles.heroActions}>
          <button className={landingStyles.primaryButton} onClick={startMeeting}>
            Start Instant Meeting
          </button>
          <button className={landingStyles.secondaryButton} onClick={scheduleMeeting}>
            Schedule Meeting
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section className={landingStyles.features}>
        <div className={landingStyles.featuresGrid}>
          {/* Feature 1 */}
          <div className={landingStyles.featureCard}>
            <div className={landingStyles.featureIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <h3 className={landingStyles.featureTitle}>Secure by Default</h3>
            <p className={landingStyles.featureDescription}>
              End-to-end encryption and robust infrastructure ensures your private rooms state and media tracks remain completely confidential.
            </p>
          </div>

          {/* Feature 2 */}
          <div className={landingStyles.featureCard}>
            <div className={landingStyles.featureIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
            <h3 className={landingStyles.featureTitle}>Global Performance</h3>
            <p className={landingStyles.featureDescription}>
              Sub-50ms latency powered by LiveKit's edge network. Seamlessly connects participants across the globe without degradation.
            </p>
          </div>

          {/* Feature 3 */}
          <div className={landingStyles.featureCard}>
            <div className={landingStyles.featureIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
            </div>
            <h3 className={landingStyles.featureTitle}>Seamless Scheduling</h3>
            <p className={landingStyles.featureDescription}>
              Integrated workflow allowing you to whitelist invitations and synchronize meetings across your calendar efficiently.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={landingStyles.cta}>
        <h2 className={landingStyles.ctaTitle}>Ready to connect?</h2>
        <p className={landingStyles.ctaDescription}>
          Join thousands of developers and teams building the future of real-time communication.
        </p>
        <button className={landingStyles.primaryButton} onClick={startMeeting}>
          Create Instant Room
        </button>
      </section>

      {/* Footer */}
      <footer className={landingStyles.footer}>
        <div className={landingStyles.footerBrand}>
          <img
            src="/images/skillmate-meet-home.png"
            alt="Skillmate Meet"
            style={{ height: 20, opacity: 0.6 }}
          />
        </div>
        <p className={landingStyles.footerText}>
          Powered by LiveKit &amp; Next.js
        </p>
      </footer>
    </div>
  );
}

export default function Page() {
  return (
    <Suspense fallback={<div style={{ height: '100vh', backgroundColor: '#050505' }} />}>
      <MainContent />
    </Suspense>
  );
}
